import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetCoordinatorService } from '../core/services/issue/widget-coordinator.service';
import { EditDialogService } from '../core/components/editDialog/editDialogService';
import { SIDEBAR_ENTITY_HANDLERS } from '../core/services/sidebar/sidebar-deep-link.service';
import { SidebarPortalHostComponent } from '../core/services/sidebar/sidebar-portal-host.component';
import { SettingsService } from '../core/services/settings/settings.service';
import { ToastService } from '../core/services/toast/toast.service';
import { CoreModule } from '../core/core.module';
import { LightgalleryModule } from 'lightgallery/angular';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared-module/shared.module';
import { FormService } from '../tour-planning/shared/services/form/form.service';

import { AceModule } from 'ngx-ace-wrapper';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { OrderModule } from '../order-module/order.module';
import { AddressAutocompleteComponent } from '../shared-module/components/address-autocomplete/address-autocomplete.component';
import { AddressDialogComponent } from '../shared-module/components/address-dialog/address-dialog.component';
import { AssignmentDialogComponent } from './components/assignment-dialog/assignment-dialog.component';
import { ContactPersonDialogComponent } from './components/contact-person-dialog/contact-person-dialog.component';
import { ResourceDialogComponent } from './components/resource-dialog-component/resource-dialog.component';
import { SettingsComponent } from './components/settings/settings.component';
import { TaskAssignmentComponent } from './components/task-assignment-component/task-assignment.component';
import { TaskAssignmentListAssignedComponent } from './components/task-assignment-list-assigned/task-assignment-list-assigned.component';
import { TaskAssignmentListCompletedComponent } from './components/task-assignment-list-completed/task-assignment-list-completed.component';
import { TaskAssignmentListUnassignedComponent } from './components/task-assignment-list-unassigned/task-assignment-list-unassigned.component';
import { AddressTaskViewComponent } from './components/task-view-components/address-task-view.component';
import { AssignmentTaskViewComponent } from './components/task-view-components/assignment-task-view.component copy';
import { CompleteButtonTaskViewComponent } from './components/task-view-components/complete-task-button-task-view.component';
import { CompletedByTaskViewComponent } from './components/task-view-components/completed-by-task-view.component';
import { ContactTaskViewComponent } from './components/task-view-components/contact-task-view.component';
import { DescriptionTaskViewComponent } from './components/task-view-components/description-task-view.component';
import { HeaderTaskViewComponent } from './components/task-view-components/header-task-view.component';
import { LocationTaskViewComponent } from './components/task-view-components/location-task-view.component';
import { OrderTaskViewComponent } from './components/task-view-components/order-task-view.component';
import { ResourcesTaskViewComponent } from './components/task-view-components/resources-task-view.component';
import { TimeEntriesTaskViewComponent } from './components/task-view-components/time-entries-task-view.component';
import { ArticlesListComponent } from './containers/articles-list/articles-list.component';
import { ContactPersonListComponent } from './containers/contact-person-list/contact-person-list.component';
import { RentalResourceAssignmentRefuelFormComponent } from './containers/custom-forms/rental-resource-assignment-refuel-form/rental-resource-assignment-refuel-form.component';
import { RentalResourceAssignmentReviewFormComponent } from './containers/custom-forms/rental-resource-assignment-review-form/rental-resource-assignment-review-form.component';
import { CustomerViewComponent } from './containers/customer-view/customer-view.component';
import { CustomersListComponent } from './containers/customers-list/customers-list.component';
import { DashboardTaskListComponent } from './containers/dashboard-task-list/dashboard-task-list.component';
import { DashboardTourListComponent } from './containers/dashboard-tour-list/dashboard-tour-list.component';
import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { GeneralSettingsComponent } from './containers/general-settings/general-settings.component';
import { LocationDialogComponent } from './containers/location-dialog/location-dialog.component';
import { LocationViewComponent } from './containers/location-view/location-view.component';
import { LocationsListComponent } from './containers/locations-list/locations-list.component';
import { MyTasksComponent } from './containers/my-tasks/my-tasks.component';
import { NexcoreOperatedRentaltTaskViewComponent } from './containers/nexcore-operated-rental-task-view/nexcore-operated-rental-task-view.component';
import { NexcoreRentalResourceAssignmenmtInTaskViewComponent } from './containers/nexcore-rental-resourceAssignment-in-task-view/nexcore-rental-resourceAssignment-in-task-view.component';
import { NexcoreRentalResourceAssignmenmtOutTaskViewComponent } from './containers/nexcore-rental-resourceAssignment-out-task-view/nexcore-rental-resourceAssignment-out-task-view.component';
import { NexcoreDefaultTaskViewComponent } from './containers/nexcore_default_task_view/nexcore-default-task-view.component';
import { NexcoreRentalResourceAssignmenmtReviewTaskViewComponent } from './containers/nexcore_nexcore-rental-resourceAssignment-review_view/nexcore-rental-resourceAssignment-review-task-view.component';
import { NexcoreRentalResourceAssignmenmtRefuelTaskViewComponent } from './containers/nexcore_rental_resourceAssignmenmt_refuel_view/nexcore-rental-resourceAssignmenmt-refuel-task-view.component';
import { ResourceAssignmentsListComponent } from './containers/resource-assignments-list/resource-assignments-list.component';
import { ResourceViewComponent } from './containers/resource-view/resource-view.component';
import { ResourcesListComponent } from './containers/resources-list/resources-list.component';
import { SettingsOverviewBoxComponent } from './containers/settings-overview-box/settings-overview-box.component';
import { SettingsOverviewComponent } from './containers/settings-overview/settings-overview.component';
import { TaskDetailViewComponent } from './containers/task-detail-view/task-detail-view.component';
import { TasksComponent } from './containers/tasks/tasks.component';
import { ContactPersonService } from './shared/services/contactPerson/contactPerson.service';
import { GoogleService } from './shared/services/google.service';
import { HereService } from './shared/services/here.service';
import { LocationService } from './shared/services/location/location.service';
import { ResourceService } from './shared/services/resource/resource.service';
import { TaskLinkService } from './shared/services/taskLink/tasksLink.service';
import { TasksService } from './shared/services/tasks/tasks.service';
import { TaskViewComponent } from './containers/task-view/task-view.component';
import { TaskViewSidebarWrapperComponent } from './containers/task-view/task-view-sidebar-wrapper.component';
import { TaskStatusWidgetComponent } from './containers/task-view/components/task-status-widget.component';
import { TaskTypeService } from './shared/services/taskType/taskType.service';
import { AssignTaskWidgetComponent } from './components/assign-task/assign-task-widget.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { UpdateTaskAddressWidgetComponent } from './components/update-task-address/update-task-address-widget.component';
import { TaskCompleteComponent } from './components/task-complete-component/task-complete.component';
import { TASK_FORM_HANDLERS } from './components/task-complete-component/handlers/task-form-handler-registry.service';
import { DefaultFormHandler } from './components/task-complete-component/handlers/default-form.handler';
import { OperatedRentalUserTaskFormHandler } from './components/task-complete-component/handlers/operated-rental-user-task-form.handler';
import { RentalResourceAssignmentReviewFormHandler } from './components/task-complete-component/handlers/rental-resource-assignment-review-form.handler';
import { ResourceHandoverFormHandler } from './components/task-complete-component/handlers/resource-handover-form.handler';
import { ResourceRefuelFormHandler } from './components/task-complete-component/handlers/resource-refuel-form.handler';
import { DefaultFormViewComponent } from './components/task-complete-component/handlers/components/default-form-view.component';
import { GenericFormViewComponent } from './components/task-complete-component/handlers/components/generic-form-view.component';
import { UpdateTaskLocationWidgetComponent } from './components/update-task-location/update-task-location-widget.component';
import { ReviewFormViewComponent } from './components/task-complete-component/handlers/components/review-form-view.component';
import { RefuelFormViewComponent } from './components/task-complete-component/handlers/components/refuel-form-view.component';
import { RefuelFormDialogComponent } from './components/task-complete-component/handlers/components/refuel-form-dialog.component';
import { ReviewFormDialogComponent } from './components/task-complete-component/handlers/components/review-form-dialog.component';
import { ResourceHandoverFormViewComponent } from './components/task-complete-component/handlers/components/resource-handover-form-view.component';
import { OperatedRentalUserTaskFormViewComponent } from './components/task-complete-component/handlers/components/operated-rental-user-task-form-view.component';
import { FormViewDialogComponent } from './components/task-complete-component/handlers/components/form-view-dialog.component';
import { TasksPageComponent } from './containers/tasks-page/tasks-page.component';
import { IssuesPageComponent } from './containers/issues-page/issues-page.component';
@NgModule({
  declarations: [
    SettingsComponent,
    DashboardComponent,
    CustomersListComponent,
    ResourcesListComponent,
    ArticlesListComponent,
    LocationsListComponent,
    LocationViewComponent,
    LocationDialogComponent,
    ResourceViewComponent,
    ContactPersonListComponent,
    CustomerViewComponent,
    ResourceDialogComponent,
    TaskAssignmentComponent,
    GeneralSettingsComponent,
    DashboardTourListComponent,
    DashboardTaskListComponent,
    ContactPersonDialogComponent,
    AddressDialogComponent,
    TaskAssignmentListUnassignedComponent,
    TaskAssignmentListAssignedComponent,
    TaskAssignmentListCompletedComponent,
    AddressAutocompleteComponent,
    SettingsOverviewComponent,
    SettingsOverviewBoxComponent,
    AssignmentDialogComponent,
    MyTasksComponent,
    TasksComponent,
    TaskDetailViewComponent,
    TaskViewComponent,
    TaskViewSidebarWrapperComponent,
    RentalResourceAssignmentReviewFormComponent,
    RentalResourceAssignmentRefuelFormComponent,
    ResourceAssignmentsListComponent,
    NexcoreDefaultTaskViewComponent,
    CompletedByTaskViewComponent,
    AssignmentTaskViewComponent,
    ContactTaskViewComponent,
    AddressTaskViewComponent,
    ResourcesTaskViewComponent,
    DescriptionTaskViewComponent,
    CompleteButtonTaskViewComponent,
    NexcoreRentalResourceAssignmenmtRefuelTaskViewComponent,
    OrderTaskViewComponent,
    LocationTaskViewComponent,
    HeaderTaskViewComponent,
    NexcoreRentalResourceAssignmenmtReviewTaskViewComponent,
    NexcoreRentalResourceAssignmenmtInTaskViewComponent,
    NexcoreRentalResourceAssignmenmtOutTaskViewComponent,
    TimeEntriesTaskViewComponent,
    NexcoreOperatedRentaltTaskViewComponent,
    TaskStatusWidgetComponent,
    AssignTaskWidgetComponent,
    UpdateTaskAddressWidgetComponent,
    TaskCompleteComponent,
    DefaultFormViewComponent,
    GenericFormViewComponent,
    ReviewFormViewComponent,
    RefuelFormViewComponent,
    RefuelFormDialogComponent,
    ReviewFormDialogComponent,
    ResourceHandoverFormViewComponent,
    OperatedRentalUserTaskFormViewComponent,
    UpdateTaskLocationWidgetComponent,
    FormViewDialogComponent,
    TasksPageComponent,
    IssuesPageComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    LightgalleryModule,
    OrderModule,
    AceModule,
    MultiSelectModule,
    TableModule,
    TabViewModule,
    DropdownModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    TooltipModule,
    PaginatorModule,
    TagModule,
    OverlayPanelModule,
    CheckboxModule,
    InputSwitchModule,
    ProgressSpinnerModule,
    SidebarPortalHostComponent,
    ButtonModule,
  ],
  exports: [
  ],
  providers:[
    LocationService,
    DatePipe,
    TasksService,
    ResourceService,
    FormService,
    SettingsService,
    ContactPersonService,
    HereService,
    GoogleService,
    DialogService,
    EditDialogService,
    ToastService, 
    TaskLinkService,
    TaskTypeService,
    WidgetCoordinatorService,
    // Sidebar entity handler for deep-linking
    {
      provide: SIDEBAR_ENTITY_HANDLERS,
      useValue: {
        entityType: 'task',
        component: TaskViewSidebarWrapperComponent,
        inputKey: 'taskId'
      },
      multi: true
    },
    // Task form handlers (Strategy pattern with multi-providers)
    {
      provide: TASK_FORM_HANDLERS,
      useClass: DefaultFormHandler,
      multi: true
    },
    {
      provide: TASK_FORM_HANDLERS,
      useClass: ResourceRefuelFormHandler,
      multi: true
    },
    {
      provide: TASK_FORM_HANDLERS,
      useClass: OperatedRentalUserTaskFormHandler,
      multi: true
    },
    {
      provide: TASK_FORM_HANDLERS,
      useClass: RentalResourceAssignmentReviewFormHandler,
      multi: true
    },
    {
      provide: TASK_FORM_HANDLERS,
      useClass: ResourceHandoverFormHandler,
      multi: true
    }
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class RentModule { }
